module.exports = __webpack_public_path__ + "static/media/terceracita.1ffbda99.png";